import request from '@/utils/request'

// 获取组织机构树形数据
export function WeGetOrganTree (params) {
  return request({
    url: 'Organ/WeGetOrganTree',
    method: 'get',
    params
  })
}
// 获取组织机构树
export function GetOrganTree (query) {
  return request({
    url: 'Organ/GetOrganTree',
    method: 'get',
    params: query
  })
}
// 获取组织机构树
export function GetOrganList (query) {
  return request({
    url: 'Organ/GetOrganList',
    method: 'get',
    params: query
  })
}
// 获取组织机构
export function WeGetAppletOrganList (query) {
  return request({
    url: 'Organ/WeGetAppletOrganList',
    method: 'get',
    params: query
  })
}

export function GetChildOrgansNullToken (query) {
  return request({
    url: 'Organ/GetChildOrgansNullToken',
    method: 'get',
    params: query
  })
}

// 获取老人信息列表
export function GetOldManPage (query) {
  return request({
    url: 'OldMan/GetOldManPage',
    method: 'get',
    params: query
  })
}

// 获取老人详情
export function GetOldManDetail (query) {
  return request({
    url: 'OldMan/GetOldMan',
    method: 'get',
    params: query
  })
}
// 保存老人信息
export function saveOldMan (data) {
  return request({
    url: 'OldMan/SaveOldMan',
    method: 'post',
    data
  })
}